import { NavigationGuardNext, Route } from 'vue-router';
import store from '@/store';

export const MyAssignmentsPage = (to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
  store.dispatch('myAssignmentsPage/getMyAssignments');
  next();
};
